import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { DashboardFilters } from '../components/dashboard/DashboardFilters';
import { KPIGrid } from '../components/dashboard/KPIGrid';
import { ChartCAMonthly } from '../components/dashboard/ChartCAMonthly';
import { ChartCAByClientType } from '../components/dashboard/ChartCAByClientType';
import { ChartCAByUser } from '../components/dashboard/ChartCAByUser';
import { ChartTopClients } from '../components/dashboard/ChartTopClients';
import {
  filtersFromSearchParams,
  filtersToSearchParams,
  presetLabel,
  type DashboardFiltersState,
} from '../components/dashboard/filters';

export function DashboardPage(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = filtersFromSearchParams(searchParams);

  const onFiltersChange = (next: DashboardFiltersState): void => {
    setSearchParams(filtersToSearchParams(next), { replace: true });
  };

  const year = new Date().getUTCFullYear();

  return (
    <div className="max-w-7xl space-y-6">
      <header className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Dashboard</h1>
          <p className="text-xs text-slate-500 mt-1">{presetLabel(filters)}</p>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/ventes/nouveau">
            <Button>Saisir une vente</Button>
          </Link>
          <Link to="/import-historique">
            <Button variant="secondary">Importer l'historique</Button>
          </Link>
        </div>
      </header>

      <DashboardFilters value={filters} onChange={onFiltersChange} />

      <KPIGrid filters={filters} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChartCAMonthly year={year} userId={filters.user_id} />
        <ChartCAByClientType filters={filters} />
        <ChartCAByUser filters={filters} />
        <ChartTopClients filters={filters} limit={5} />
      </div>
    </div>
  );
}
